import { UserOutlined, LockOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Col } from 'antd';
import { Formik, FormikHelpers } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { images } from 'assets';
import { AppDispatch, LoginRequest } from 'types';
import validationSchema from './schema';
import StyledWrapper from './styles';
import { login } from './thunk';

const LoginPage: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch<AppDispatch>();
  const [errorsSubmit, setErrorsSubmit] = useState<string | undefined>();

  useEffect(() => {
    if (localStorage['token']) {
      history.push('/');
    }
  }, [history]);

  //need refactoring
  const handleSubmit = useCallback(
    async (values: LoginRequest, form: FormikHelpers<LoginRequest>) => {
      const resultAction = await dispatch(login(values));
      if (login.fulfilled.match(resultAction)) {
        history.push('/');
        form.setSubmitting(false);
      }
      setErrorsSubmit('メールアドレスまたはパスワードが間違っています');
    },
    [dispatch, history],
  );

  return (
    <StyledWrapper>
      <div className="boxLogin">
        <div className="header">
          <div className="logo">
            <img src={images.logo} alt="logo" />
          </div>
        </div>
        <div className="section">
          <p className="title font-Arial">CPAP MS</p>
          <p className="titleMini font-Arial">Management System</p>
          <p className="text">ログイン</p>
          <Formik
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            initialValues={initialValues}
            render={() => (
              <Form>
                <Col span={18} offset={3}>
                  {errorsSubmit ? (
                    <div className="errors">
                      <InfoCircleOutlined />
                      {errorsSubmit}
                    </div>
                  ) : (
                    ''
                  )}
                  <Form.Item name="username">
                    <Input
                      onClick={() => setErrorsSubmit(undefined)}
                      className="input"
                      prefix={<UserOutlined />}
                      name="username"
                      placeholder="メールアドレス"
                    />
                  </Form.Item>
                  <Form.Item name="password">
                    <Input
                      onClick={() => setErrorsSubmit(undefined)}
                      prefix={<LockOutlined />}
                      className="input"
                      name="password"
                      placeholder="パスワード"
                      type="password"
                    />
                  </Form.Item>
                  <SubmitButton className="btnSubmit">ログイン</SubmitButton>
                </Col>
              </Form>
            )}
          />
        </div>
      </div>
    </StyledWrapper>
  );
};

const initialValues: any = {
  username: '',
  password: '',
};

export default LoginPage;
